import React, { useEffect, useState } from "react";
import CourseCard from "../CourseCard/CourseCard";
import "./Courses.css";
const Courses = () => {
  const [mainCourses, setMainCourses] = useState([]);
  useEffect(() => {
    fetch("/course-data.json")
      .then((res) => res.json())
      .then((data) => setMainCourses(data));
  }, []);
  return (
    <div className="container mb-5 mt-5">
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {mainCourses.map((mainCourse) => (
          <CourseCard mainCourse={mainCourse}></CourseCard>
        ))}
      </div>
    </div>
  );
};

export default Courses;
